import { useMemo } from "react";
import HoldingsStatementSelector from "./HoldingsStatementSelector";

const getPortfolioId = (portfolio) =>
  String(portfolio?.PortfolioId ?? portfolio?.portfolioId ?? portfolio?.Id ?? portfolio?.id ?? "");

const getPortfolioName = (portfolio) =>
  portfolio?.PortfolioName ??
  portfolio?.portfolioName ??
  portfolio?.Text ??
  portfolio?.text ??
  portfolio?.PortFolioName ??
  "";

const HoldingsPortfolioSelector = ({
  selectedPortfolios,
  selectedPortfolioIds,
  onSelectionChange,
}) => {
  const options = useMemo(
    () =>
      (selectedPortfolios || []).map((portfolio) => ({
        id: getPortfolioId(portfolio),
        text: getPortfolioName(portfolio),
      })),
    [selectedPortfolios]
  );

  return (
    <HoldingsStatementSelector
      label="Portfolio:"
      emptyText="No portfolio(s) available"
      placeholder="Select portfolio(s)"
      singularSummarySuffix="portfolio selected"
      pluralSummarySuffix="portfolios selected"
      options={options}
      selectedIds={selectedPortfolioIds}
      onSelectionChange={onSelectionChange}
      wrapperClassName="holdings-portfolio-filter"
    />
  );
};

export default HoldingsPortfolioSelector;
